import FeatureModal from './FeatureModal'

export default FeatureModal
